export default __webpack_public_path__ + "static/media/store-level-2.e444b959.png";